module.exports = __webpack_public_path__ + "static/media/img006.045b7979.jpg";